import React, { useCallback, useEffect, useState } from "react";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import {
  CustomPagination,
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
} from "../../Utils/Tables/CustomTable";
import Form from "react-bootstrap/Form";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons/faFileInvoice";

import {
  titleCase,
  dateStringTimeConvert,
} from "../../Utils/titleCaseFunction";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import axios from "axios";
import config from "../../Helpers/config.json";
import { useSalesFilter } from "./CustomHooks/useSalesFilter";
import { InvoiceDateFilter } from "./InvoiceDateFilter";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { errorMessages } from "../../Helpers/ErrorMessages";
import Label from "../../Utils/FormInputs/Label";
import Textarea from "../../Utils/FormInputs/Textarea";
import CustomDialog from "../../Utils/Dialog/CustomDialog";
import { LoadingGif } from "../../Utils/Loader";
import { CancelDialog } from "../../Utils/DeleteDialog";
import { SalesReceiptTemplate } from "./SalesReceiptTemplate";

import { bindActionCreators } from "redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { connect } from "react-redux";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { useExcelReports, usePdfReports } from "./CustomHooks/useExcelReports";
import { useThermalPrint } from "../../Utils/Template/useThermalPrint";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import { formatDigits } from "../../Utils/formatAmount";
import { formatAmount } from "../../Utils/formatAmount";

const headData = [
  { id: "sl", numeric: false, disablePadding: false, label: "Sl" },
  { id: "date", numeric: false, disablePadding: false, label: "Date" },
  { id: "invoice", numeric: false, disablePadding: false, label: "Receipt#" },
  { id: "name", numeric: false, disablePadding: false, label: "Customer Name" },
  { id: "total", numeric: false, disablePadding: false, label: "Total Amount" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
  { id: "sale_type", numeric: false, disablePadding: false, label: "Sell type" },
  { id: "action", numeric: false, disablePadding: false, label: "Action" },
];

const useStyles = makeStyles((theme) => ({
  icon: {
    width: "0.8em",
    height: "0.8em",
  },
  paid: {
    color: "#1d5dd3",
  },
  canceled: {
    color: "#a30c0c",
  },
}));

function SalesReceipts({ actions, snackbars }) {
  const classes = useStyles();
  const storage = JSON.parse(sessionStorage.getItem("total_count"));
  const item_count = storage ? storage : 0;
  const count = () => +item_count || 0;

  const [term, setTerm] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [total_Amount, setAmount] = useState(0);
  const [loading, setLoading] = useState("idle"); // main list loading
  const [salesReceipts, setSalesReceipts] = useState([]);
  const [total_count, setTotalCount] = useState(count);

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState("idle");

  const [openInvoice, setOpenInvoice] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [submit, setHasSubmitted] = useState(false);
  const [reason, setReason] = useState("");
  const [invoice_number, setInvoiceNumber] = useState("");
  const [sale_type_detail, setSale_Type_Detail] = useState("");
  const [company, setCompany] = useState({});
  const [loadingCompany, setLoadingCompany] = useState("idle");

  // Loading states
  const [loadingCancelPreview, setLoadingCancelPreview] = useState(false);    // loading receipt preview
  const [loadingCancelOperation, setLoadingCancelOperation] = useState(false); // cancel OR save-as-draft full operation

  const [receiptData, setReceiptData] = useState({
    products: [],
    customer: {},
    loading: "idle",
  });

  const { handlePrint, componentRef } = useThermalPrint(`Thermal Receipt ${invoice_number}`);

  const { date, handleChange, filters } = useSalesFilter();
  const { filter_by, start_date, end_date } = date;

  useEffect(() => {
    setActivePage(1);
  }, [filter_by]);

  useEffect(() => {
    setLoadingCompany("loading");
    axios
      .get(`${config.epharmUrl}/User/view_company_info`)
      .then((res) => {
        setCompany(res.data || {});
        setLoadingCompany("success");
      })
      .catch((err) => {
        console.error("Failed to load company info", err);
        setLoadingCompany("error");
      });
  }, []);

  const retrieveReceipts = useCallback(
    (start_date, end_date, page = activePage) => {
      const isCustom = filter_by === "custom" ? { start_date, end_date } : {};
      setLoading("loading");
      axios
        .get(`${config.epharmUrl}/Cinvoice/invoices`, {
          params: {
            category: "receipts",
            time_filter: filter_by,
            page_number: page,
            search: term,
            ...isCustom,
          },
        })
        .then((response) => {
          const res = response.data;
          const dt = res.data || {};
          const arr = dt.invoices || {};
          const receiptArr = arr.invoice_list || [];
          const t_amount = arr.grand_total_amount || 0;
          const total_amount = arr.total_amount || 0;
          const t_count = dt.total_records || 0;

          if (activePage === 1) {
            sessionStorage.setItem("total_count", JSON.stringify(t_count));
            setTotalCount(t_count);
          } else {
            setTotalCount(count);
          }

          setTotalAmount(t_amount);
          setAmount(total_amount);
          setLoading("success");
          setSalesReceipts(receiptArr);
        })
        .catch((error) => {
          errorMessages(error, null, actions);
          setLoading("error");
        });
    },
    [activePage, filter_by, term]
  );

  useEffect(() => {
    if (filter_by === "custom" && isSubmitted !== "resolved") return;
    retrieveReceipts(start_date, end_date);
  }, [retrieveReceipts, filter_by, start_date, end_date, isSubmitted]);

  const handler = (event) => setTerm(event.target.value);

  const handleFilter = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (start_date && end_date && start_date <= end_date) {
      setIsSubmitted("resolved");
      retrieveReceipts(start_date, end_date);
    }
  };

  const handleOpenInvoice = (item) => {
    const {
      invoice_number: inv_number,
      receipt_number: recep_number,
      customer_id: cus_id,
      sale_type: sale_typs,
    } = item;

    setSale_Type_Detail(sale_typs);
    setInvoiceNumber(inv_number);
    setOpenInvoice(true);

    setLoadingCancelPreview(true);
    setReceiptData((prev) => ({ ...prev, loading: "loading" }));

    const formData = new FormData();
    formData.append("receipt_number", recep_number);
    formData.append("invoice_number", "");
    formData.append("customer_id", cus_id);

    axios
      .post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        const dataRes = response.data || {};
        const arr = dataRes.bill || [];
        const customer_details = dataRes.customer_details || {};
        const obj = arr[0] || {};

        setReceiptData({
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setReceiptData((prev) => ({ ...prev, loading: "error" }));
      })
      .finally(() => {
        setLoadingCancelPreview(false);
      });
  };

  const handleOpenPrint = (item) => {
    const {
      receipt_number: recep_number,
      customer_id: cus_id,
      invoice_number: inv_number,
    } = item;

    setInvoiceNumber(inv_number);

    const formData = new FormData();
    formData.append("receipt_number", recep_number);
    formData.append("invoice_number", "");
    formData.append("customer_id", cus_id);

    setReceiptData((prev) => ({ ...prev, loading: "loading" }));

    axios
      .post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        const dataRes = response.data || {};
        const arr = dataRes.bill || [];
        const customer_details = dataRes.customer_details || {};
        const obj = arr[0] || {};

        setReceiptData({
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
        handlePrint();
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        setReceiptData((prev) => ({ ...prev, loading: "error" }));
      });
  };

  const handleDelete = (is_draft = false) => {
    if (!reason.trim()) return;

    setLoadingCancelOperation(true);
  

    axios
      .post(`${config.epharmUrl}/Cinvoice/cancel_invoice`, {
        invoice_number,
        reason: reason.trim(),
      })
      .then(() => {
        actions.snackbarActions.successSnackbar(
          is_draft ? "Saved as draft successfully" : "Invoice canceled successfully"
        );
        // setIsSubmitted("resolved");

        setReason("");
        setOpenDialog(false);
        setOpenInvoice(false);
        setOpenConfirmation(false);
        setSale_Type_Detail("");

        if (is_draft) {
          sessionStorage.setItem(invoice_number, JSON.stringify(receiptData));
          const path =
            sale_type_detail === "retail"
              ? `/new-receipt/${invoice_number}`
              : `/WholeSale-receipt/${invoice_number}/${sale_type_detail}`;
          history.push(path);
        }
        retrieveReceipts(start_date, end_date, activePage);

      })
      .catch((error) => {
        errorMessages(error, null, actions);
      })
      .finally(() => {
        setLoadingCancelOperation(false);
        setHasSubmitted(false);
      });
  };

  const handleOpenConfirmation = () => {
    setHasSubmitted(true);
    if (reason.trim()) {
      setOpenConfirmation(true);
    }
  };

  const handleSaveDraft = () => handleDelete(true);
  const handleCancelInvoice = () => handleDelete(false);

  const handleCloseInvoice = () => setOpenInvoice(false);
  const handleCloseConfirmation = () => setOpenConfirmation(false);
  const handleCloseDialog = () => setOpenDialog(false);

  const handlePageChange = (pageNumber) => setActivePage(pageNumber);

  const { products, customer, loading: loadingInvoice } = receiptData;

  const isLoading = loading === "loading";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const isLoadingInvoice =
    loadingInvoice === "loading" || loadingCancelPreview || loadingCompany === "loading";
  const isSuccessInvoice = loadingInvoice === "success" && !loadingCancelPreview;

  const { exportExcel } = useExcelReports(actions, {
    file_name: "Sales",
    url: "Cinvoice/manage_sales_excel_report",
    params: {
      download: true,
      category: "receipts",
      time_filter: filter_by,
      ...(filter_by === "custom" ? { start_date, end_date } : {}),
    },
  });

  const { exportPDF } = usePdfReports(actions, {
    file_name: "Sales",
    url: "Cinvoice/manage_sales_pdf_report",
    download: true,
    params: {
      download: true,
      category: "receipts",
      time_filter: filter_by,
      ...(filter_by === "custom" ? { start_date, end_date } : {}),
    },
  });

  const handleExcelExport = () => {
    if (!salesReceipts?.length) {
      actions.snackbarActions.errorSnackbar("There are no records to download");
      return;
    }
    exportExcel();
  };

  const components = [
    { label: "Receipts", path: "/sales-receipts" },
    { label: "Invoices", path: "/manageinvoice" },
    { label: "Cancelled Sales", path: "/cancelledsales" },
  ];

  const buttons = (
    <>
      <button
        className="btn pharmacy-info-btn btn-sm mr-3"
        data-testid="continue-cancel"
        onClick={() => setOpenDialog(true)}
      >
        Continue
      </button>
      <button
        className="btn pharmacy-grey-btn btn-sm"
        data-testid="no-cancel-button"
        onClick={handleCloseInvoice}
      >
        No
      </button>
    </>
  );

  const reasonForm = (
    <Form.Group>
      <Label name="Please enter reason for cancelling receipt" type />
      <Textarea
        type="text"
        placeholder="please type reason here..."
        name="Reason"
        data-testid="reason-text-cancel"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        submitted={submit}
      />
      {submit && !reason && (
        <div className="invalid-text">Please enter a reason</div>
      )}
    </Form.Group>
  );

  return (
    <div>
      <ReusableDashboardHeader
        component="Manage Sales"
        heading="Sales"
        subHeading="Receipts"
        link={history.location.pathname}
      />

      <PharmacySnackbar
        open={snackbars.open}
        message={snackbars.message}
        variant={snackbars.variant}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      {/* Full-screen loader during CANCEL or SAVE-AS-DRAFT operation */}
      {loadingCancelOperation && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div className="text-center text-white">
            <LoadingGif />
            <p className="mt-3 fs-5">
              Please wait... {openConfirmation ? "Saving as draft" : "Cancelling receipt"}
            </p>
          </div>
        </div>
      )}

      <div className="receipt-container">
        {/* Cancel Receipt Preview Dialog */}
        <CustomDialog
          maxWidth="md"
          title="Cancel Receipt"
          open={openInvoice}
          handleClose={handleCloseInvoice}
          buttons={buttons}
          isOverflow={false}
        >
          {isLoadingInvoice ? (
            <div className="text-center mt-5 mb-5">
              <LoadingGif />
              <p className="mt-3">Please wait... Loading receipt details</p>
            </div>
          ) : isSuccessInvoice ? (
            <SalesReceiptTemplate {...{ customer, products }} />
          ) : (
            <div className="text-center mt-5">
              The server did not return a valid response
            </div>
          )}
        </CustomDialog>

        {/* Reason for Cancel Dialog */}
        <CancelDialog
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          heading="Cancel Receipt"
          message={reasonForm}
        >
          <button
            className="btn pharmacy-info-btn btn-sm mr-3"
            disabled={loadingCancelOperation}
            data-testid="cancel_receipt"
            onClick={handleOpenConfirmation}
          >
            {loadingCancelOperation ? "Processing..." : "Cancel Receipt"}
          </button>
          <button
            data-testid="dont_cancel_receipt"
            className="btn pharmacy-grey-btn btn-sm"
            disabled={loadingCancelOperation}
            onClick={handleCloseDialog}
          >
            Don't Cancel Receipt
          </button>
        </CancelDialog>

        {/* Save as Draft Confirmation */}
        <CancelDialog
          openDialog={openConfirmation}
          handleClose={handleCloseConfirmation}
          heading="Use invoice as draft"
          message={
            loadingCancelOperation ? (
              <div className="text-center py-4">
                <LoadingGif />
                <p className="mt-3">Saving as draft... Please wait</p>
              </div>
            ) : (
              "Would you like to use this receipt as a draft?"
            )
          }
        >
          {loadingCancelOperation ? null : (
            <>
              <button
                className="btn pharmacy-info-btn btn-sm mr-3"
                data-testid="yes-draft"
                onClick={handleSaveDraft}
              >
                Yes
              </button>
              <button
                className="btn pharmacy-grey-btn btn-sm"
                onClick={handleCancelInvoice}
                data-testid="no-draft"
              >
                No
              </button>
            </>
          )}
        </CancelDialog>

        <div className="mb-3">
          <ReusableRouteTabs value={history.location.pathname} tabHeading={components} />
        </div>

        <div style={{ display: "none" }}>
          <div ref={componentRef} className="card styled-pos-card">
            <SalesReceiptTemplate {...{ products, customer }} />
          </div>
        </div>

        <InvoiceDateFilter
          {...{ filters, date, handleChange, handleFilter, submitted }}
        />

        <MuiPaper>
          <EnhancedTableToolbar title="Receipts">
            <span className="btn-group" style={{ flex: "1 1 100%" }}>
              <button
                onClick={handleExcelExport}
                className="btn btn-sm pharmacy-btn mr-1"
              >
                Download Excel
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={exportPDF}
                className="btn btn-sm pharmacy-btn mr-1"
              >
                Download PDF
              </button>
            </span>
            <Form.Control
              type="text"
              value={term ? titleCase(term) : ""}
              data-testid="search_list"
              onChange={handler}
              className="form__control"
              placeholder="Search"
              style={{ float: "right" }}
            />
          </EnhancedTableToolbar>

          <div className="sub-journal-bar" style={{ marginLeft: "0" }}>
            <h6 data-testid="total_receipts">
              Total Receipts : <strong>{formatDigits(total_count)}</strong>
            </h6>
            <h6 data-testid="running_balance">
              Total Amount : <strong>{formatAmount(totalAmount)}</strong>
            </h6>
          </div>

          <TableContainer>
            <Table aria-label="enhanced table" size="medium">
              <EnhancedTableHead headCells={headData} />

              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <img
                        src="/images/listPreloader.gif"
                        alt="loader"
                        style={{ width: "5%" }}
                      />
                    </TableCell>
                  </TableRow>
                ) : isSuccess ? (
                  salesReceipts?.length > 0 ? (
                    <>
                      {salesReceipts.slice(0, 10).map((info, index) => {
                        const status_text = { 1: "PAID", 9: "CANCELLED" };
                        const status_style = { 1: classes.paid, 9: classes.canceled };

                        const sl = (activePage - 1) * 10 + index + 1;

                        const saleTypeStyles = {
                          wholesale: { backgroundColor: "#d1fae5", color: "#065f46" },
                          retail: { backgroundColor: "#dbeafe", color: "#1e40af" },
                        };

                        const saleTypeLabels = {
                          wholesale: "Facility",
                          retail: "Client",
                        };

                        return (
                          <TableRow hover key={index}>
                            <TableCell>{sl}</TableCell>
                            <TableCell>
                              {info.date_paid ? dateStringTimeConvert(info.date_paid) : ""}
                            </TableCell>
                            <TableCell>{info.receipt_number}</TableCell>
                            <TableCell>{titleCase(info.customer_name)}</TableCell>
                            <TableCell>{info.total_amount}</TableCell>
                            <TableCell className={status_style[info.status]}>
                              {status_text[info.status]}
                            </TableCell>
                            <TableCell>
                              <span
                                style={{
                                  ...saleTypeStyles[info.sale_type?.toLowerCase()],
                                  padding: "4px 10px",
                                  borderRadius: "9999px",
                                  fontWeight: "600",
                                  fontSize: "0.875rem",
                                  display: "inline-block",
                                }}
                              >
                                {saleTypeLabels[info.sale_type?.toLowerCase()] || info.sale_type}
                              </span>
                            </TableCell>
                            <TableCell>
                              <Tooltip title="View Thermal Receipt (Compact)" placement="top">
                                <Link to={`/receipt_print/${info.customer_id}/${info.receipt_number}`}>
                                  <button className="btn btn-sm btn-info mr-2">
                                    <FontAwesomeIcon icon={faEye} /> Thermal
                                  </button>
                                </Link>
                              </Tooltip>

                              <Tooltip title="View Full A4 Receipt" placement="top">
                                <Link to={`/receipt_print_big/${info.customer_id}/${info.receipt_number}`}>
                                  <button className="btn btn-sm btn-primary mr-2">
                                    <FontAwesomeIcon icon={faFileInvoice} /> Full A4
                                  </button>
                                </Link>
                              </Tooltip>

                              <Tooltip title="Print">
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleOpenPrint({
                                      receipt_number: info.receipt_number,
                                      customer_id: info.customer_id,
                                      invoice_number: info.invoice_number,
                                    })
                                  }
                                  className="btn btn-sm pharmacy-gray-btn icon-button-holder mb-sm-2"
                                >
                                  <PrintOutlinedIcon classes={{ root: classes.icon }} />
                                </button>
                              </Tooltip>

                              {info.status === 1 && (
                                <Tooltip title="Cancel Invoice" placement="left-start">
                                  <button
                                    data-testid={`cancel_sale-${index}`}
                                    onClick={() =>
                                      handleOpenInvoice({
                                        receipt_number: info.receipt_number,
                                        invoice_number: info.invoice_number,
                                        customer_id: info.customer_id,
                                        sale_type: info.sale_type,
                                      })
                                    }
                                    className="btn btn-sm pharmacy-gray-btn icon-button-holder mb-sm-2"
                                  >
                                    <CloseIcon className={classes.icon} />
                                  </button>
                                </Tooltip>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}

                      <TableRow>
                        <TableCell colSpan={3} className="text-right">
                          Total Amount Per Page:
                        </TableCell>
                        <TableCell>{total_Amount}</TableCell>
                        <TableCell colSpan={4} />
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  )
                ) : isError ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      The server did not return a valid response
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>

          <CustomPagination
            data={salesReceipts}
            records={10}
            activePage={activePage}
            total_count={total_count}
            handleChangeNextPage={handlePageChange}
          />
        </MuiPaper>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesReceipts);